/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_nav_shorts_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thumbnails for YouTube Shorts`)
};

const es_yt_nav_shorts_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miniaturas para YouTube Shorts`)
};

const de_yt_nav_shorts_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thumbnails für YouTube Shorts`)
};

const nl_yt_nav_shorts_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thumbnails voor YouTube Shorts`)
};

const fr_yt_nav_shorts_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miniatures pour les YouTube Shorts`)
};

const it_yt_nav_shorts_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miniature per YouTube Shorts`)
};

const pt_br2_yt_nav_shorts_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thumbnails para YouTube Shorts`)
};

const pt_yt_nav_shorts_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miniaturas para YouTube Shorts`)
};

const ja_yt_nav_shorts_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube Shorts用のサムネイル`)
};

const zh_yt_nav_shorts_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube Shorts 缩略图`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_nav_shorts_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_nav_shorts_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_nav_shorts_desc", locale)
	if (locale === "en") return en_yt_nav_shorts_desc(inputs)
	if (locale === "es") return es_yt_nav_shorts_desc(inputs)
	if (locale === "de") return de_yt_nav_shorts_desc(inputs)
	if (locale === "nl") return nl_yt_nav_shorts_desc(inputs)
	if (locale === "fr") return fr_yt_nav_shorts_desc(inputs)
	if (locale === "it") return it_yt_nav_shorts_desc(inputs)
	if (locale === "pt-BR") return pt_br2_yt_nav_shorts_desc(inputs)
	if (locale === "pt") return pt_yt_nav_shorts_desc(inputs)
	if (locale === "ja") return ja_yt_nav_shorts_desc(inputs)
	return zh_yt_nav_shorts_desc(inputs)
};